import { render, staticRenderFns } from "./JeepayUpload.vue?vue&type=template&id=388b4fb4"
import script from "./JeepayUpload.vue?vue&type=script&lang=js"
export * from "./JeepayUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports